import { render, staticRenderFns } from "./AddNewCard.vue?vue&type=template&id=cfed0bf2"
import script from "./AddNewCard.vue?vue&type=script&lang=js"
export * from "./AddNewCard.vue?vue&type=script&lang=js"
import style0 from "./AddNewCard.vue?vue&type=style&index=0&id=cfed0bf2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports